export default __webpack_public_path__ + "media/images/icons_fc/todo2-867e1605aeb56cb00b27543d85491607.png";